import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import FormList from './pages/Forms/FormList';
import FormBuilder from './pages/Forms/FormBuilder';
import FormFill from './pages/Forms/FormFill';
import SubmissionList from './pages/Submissions/SubmissionList';
import UserManagement from './pages/Users/UserManagement';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />

            <Route path="/" element={<PrivateRoute><Dashboard /></PrivateRoute>} />

            {/* Forms */}
            <Route path="/forms" element={<PrivateRoute><FormList /></PrivateRoute>} />
            <Route path="/forms/create" element={<AdminRoute><FormBuilder /></AdminRoute>} />
            <Route path="/forms/edit/:id" element={<AdminRoute><FormBuilder /></AdminRoute>} />
            <Route path="/forms/fill/:id" element={<PrivateRoute><FormFill /></PrivateRoute>} />

            {/* Submissions */}
            <Route path="/submissions" element={<AdminRoute><SubmissionList /></AdminRoute>} />

            {/* Users */}
            <Route path="/users" element={<AdminRoute><UserManagement /></AdminRoute>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
